<div class="row">
    <div class="col-sm-12 p-4">
      <form novalidate="">
        <div class="custom-form">
            <div class="row justify-content-between">
              <div *ngIf="company" class="col-lg-12">
                <div class="card p-3">
                  <h5 class="mb-0 text-secondary">
                    {{ "CommercialRegistrationInformation" | translate }}
                  </h5>
                  <hr class="mb-3" />
                  <div class="row">
                      <div class="form-group row">
                          <div class="col-lg-3 mt-3">
                              <label for="CommercialRegistrationNo">{{"CommercialRegistrationNo" | translate}}</label>
                              <span class="form-control" readonly>{{company.company.crnumber}} &nbsp;</span>
                          </div>
                      </div>

                      <div class="form-group row">
                          <div class="col-lg-6  mt-3">
                              <label>{{"NameOfTheCompanyOrInstitution" | translate}}</label>
                              <span class="form-control" readonly>{{company.company.name}} &nbsp;</span>
                          </div>
                          <div class="col-lg-3 mt-3">
                              <label>{{"StartDateOfTheEstablishment" | translate}}</label>
                              <span class="form-control" readonly>{{company.company.startDate | toDateOnly}} &nbsp;</span>
                          </div>

                          <div class="col-lg-3 mt-3">
                              <label>{{"ExpirationDateOfTheEstablishment" | translate}}</label>
                              <span class="form-control" readonly>{{company.company.endDate | toDateOnly}} &nbsp;</span>
                          </div>
                      </div>
                      <div class="form-group row">
                          <div *ngIf="company.company.nationalNumber" class="col-lg-2 mt-3">
                              <label>{{ "NationalEstablishmentNumber" | translate }}</label>
                              <span class="form-control" readonly>{{company.company.nationalNumber }} &nbsp;</span>
                          </div>

                          <div *ngIf="company.company.crstatus" class="col-lg-2 mt-3">
                              <label>{{ "Status" | translate }}</label>
                              <span class="form-control" readonly>{{company.company.crstatus }} &nbsp;</span>
                          </div>

                          <div *ngIf="company.company.crType" class="col-lg-2 mt-3">
                              <label>{{ "Type" | translate }}</label>
                              <span class="form-control" readonly>{{company.company.crType}} &nbsp;</span>
                          </div>

                          <div *ngIf="company.company.city" class="col-lg-2 mt-3">
                              <label>{{ "CommercialRegistryCity" | translate }}</label>
                              <span class="form-control" readonly>{{company.company.city }} &nbsp;</span>
                          </div>
                          <div *ngIf="company.company.capital" class="col-lg-2 mt-3">
                              <label>{{ "Capital" | translate }}</label>
                              <span class="form-control" readonly>{{company.company.capital }} &nbsp;</span>
                          </div>
                      </div>
                      <div class="form-group col-lg-12 mt-3">
                          <label>{{ "Addrress" | translate }}</label>
                          <span class="form-control" readonly>{{company.company.address ? company.company.address : '' }} &nbsp;</span>
                      </div>
                      <div class="form-group col-lg-12 mt-3">
                          <label>{{ "Activity" | translate }}</label>
                          <span class="form-control" readonly>{{company.company.activity ? company.company.activity:'' }} &nbsp;</span>
                      </div>
                  </div>
                </div>
                <div class="card p-3">
                    <h5 class="mb-0 text-secondary">
                        {{ "Contributors" | translate }}
                    </h5>
                    <hr class="mb-3" />
                    <div class="row">
                        <table class="table table-striped mt-5">
                            <thead class="thead-dark">
                                <tr>
                                    <th scope="col">{{ "Name" | translate }}</th>
                                    <th scope="col">{{ "IdentityNumber" | translate }}</th>
                                    <th scope="col">{{ "RelationshipWithTheInstitution" | translate }}</th>
                                    <th scope="col">{{ "Email" | translate }}</th>
                                    <th scope="col">{{ "MobileNumber" | translate }}</th>
                                    <th scope="col">{{ "Nationality" | translate }}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let person of company.persons">
                                    <td>{{ person.name }}</td>
                                    <td>{{ person.identityNumber }}</td>
                                    <td>{{ person.relationName }}</td>
                                    <td>{{ person.email }}</td>
                                    <td>{{ person.mobile }}</td>
                                    <td><i class="flag-icon flag-icon-{{person.iso }}"></i> {{ person.nationalityName }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div class="card p-3">
                    <h5 class="mb-0 text-secondary">
                        {{ "violations" | translate }}
                    </h5>
                    <hr class="mb-3" />
                    <div class="row">
                        <app-general-violations [loadDataFP]="loadviolationdataFP"></app-general-violations>
                    </div>
                </div>
               
              </div>
            </div>
          </div>
          
      </form>
    </div>
</div>
  